module.exports = __webpack_public_path__ + "img/logo_plant3.9c5f784f.png";